import { BaseHRAdapter } from './base';
import { HRJob } from '../types';

export class AtlassianAdapter extends BaseHRAdapter {
  name = 'Atlassian';
  private apiKey: string;
  private endpoint: string;

  constructor(config: { apiKey: string; endpoint: string }) {
    super();
    this.apiKey = config.apiKey;
    this.endpoint = config.endpoint;
  }

  async connect(): Promise<boolean> {
    try {
      const response = await fetch(`${this.endpoint}/rest/api/3/myself`, {
        headers: {
          'Authorization': `Bearer ${this.apiKey}`,
          'Accept': 'application/json'
        }
      });
      return response.ok;
    } catch {
      return false;
    }
  }

  async validateCredentials(): Promise<boolean> {
    return this.connect();
  }

  async fetchJobs(): Promise<HRJob[]> {
    try {
      const response = await fetch(
        `${this.endpoint}/rest/api/3/search?jql=project="Recruitment"&expand=description,customfield_10000`,
        {
          headers: {
            'Authorization': `Bearer ${this.apiKey}`,
            'Accept': 'application/json'
          }
        }
      );
      
      if (!response.ok) throw new Error('Failed to fetch jobs from Atlassian');
      
      const data = await response.json();
      
      return data.issues.map((issue: any) => ({
        externalId: issue.key,
        title: issue.fields.summary,
        description: issue.fields.description?.content?.[0]?.content?.[0]?.text || '',
        location: issue.fields.customfield_10000?.value || 'Remote',
        type: this.normalizeJobType(issue.fields.customfield_10001?.value || 'full-time'),
        requirements: this.extractRequirements(issue.fields.description),
        source: this.name,
        sourceUrl: `${this.endpoint}/browse/${issue.key}`
      }));
    } catch (error) {
      console.error('Error fetching Atlassian jobs:', error);
      throw error;
    }
  }

  private extractRequirements(description: any): string[] {
    if (!description?.content) return [];
    
    const requirements: string[] = [];
    
    description.content.forEach((block: any) => {
      if (block.type === 'bulletList') {
        block.content.forEach((item: any) => {
          const text = item.content?.[0]?.content?.[0]?.text;
          if (text) requirements.push(text);
        });
      }
    });
    
    return requirements;
  }
}